import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Checkbox } from '../Form';
import { media } from '../../styles/media';

const Root = styled.li`
  padding: ${props => props.theme.layout.gutter / 4}px 0;

  font-family: ${props => props.theme.font.body2.fontFamily};
  font-size: ${props => props.theme.font.body2.fontSize};
  line-height: ${props => props.theme.font.body2.lineHeight};
  text-transform: initial;

  color: ${props => props.theme.color.brand.grey};

  ${media.tablet`
    padding: ${props => props.theme.layout.gutter * 0.4}px 0;
  `};
`;

class Item extends PureComponent {
  render() {
    const { id, label, onChange, checked, category } = this.props;

    return (
      <Root>
        <Checkbox
          name={id}
          onChange={onChange}
          category={category}
          checked={checked}
        >
          {label}
        </Checkbox>
      </Root>
    );
  }
}

Item.propTypes = {
  id: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  category: PropTypes.number.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired
};

export default Item;
